import styled from "styled-components";

// tslint:disable-next-line
export const StickyContent = styled.div`
  flex: auto;
  overflow: auto;
  position: relative;
`;
